import { LovValues, TemplateFieldsDisplayFn } from '../../../../../models/template.model';
import { displayFnWrapper } from '../../../utils/dynamic-data-retrievers';
import { ReportRecord } from '../../../../../models/report.model';
import { currencyLov, PropertyType, propertyTypeDisplayFnFactory, valueWithUomPrefix } from '../us.common';
import {
  US_PROPERTY_COMMON_BODY_FIELDS,
  US_PROPERTY_COMMON_FOOTER_FIELDS,
  US_PROPERTY_COMMON_HEADER_FIELDS,
} from './us-property.common';
import { map } from 'rxjs/operators';

const retailDisplayFnWrapper = propertyTypeDisplayFnFactory(PropertyType.Retail);

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...US_PROPERTY_COMMON_HEADER_FIELDS,
  ...US_PROPERTY_COMMON_BODY_FIELDS(PropertyType.Retail),
  145: {
    displayFn: (record: ReportRecord, options, opex) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const opexVal = valueWithUomPrefix(record, PropertyType.Retail, opex, currencyLOV);
          return opexVal;
        })
      );
    },
  }, // 145 - OpEx
  ...US_PROPERTY_COMMON_FOOTER_FIELDS(PropertyType.Retail),
  164: { displayFn: retailDisplayFnWrapper }, // 164 - Class
  165: { displayFn: displayFnWrapper }, // 165 - Floors
  170: { displayFn: retailDisplayFnWrapper }, // 170 - Anchor Tenants
  142: {
    displayFn: (record: ReportRecord, options, arg) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const TIAVal = valueWithUomPrefix(record, PropertyType.Retail, arg, currencyLOV);
          return TIAVal;
        })
      );
    },
  }, // 142 - Tis
};
